import { FC, useCallback } from "react";
import { dateToNiceString } from "../../../helpers/dateToNiceString";
import { observer } from "mobx-react-lite";
import StarIdle from "../../../assets/ButtonIcons/favourite-icon-idle.svg";
import StarActive from "../../../assets/ButtonIcons/favourite-icon-active.svg";
import { taskPriorityDisplay, taskStatusDisplay, taskTypeDisplay } from "../../Project/Tasks/Tasks";
import { IMonitorTaskDisplay } from "../../../common/api_interfaces/monitor/IUserMonitorTaskFullInfo";

interface TableRowProps {
    task: IMonitorTaskDisplay;
    isSelected: boolean;
    isFavourite: boolean;
    onRowClick: (taskId: number) => void;
    onFavouriteClick: (taskId: number) => void;
    taskColumnDisplay: (task: IMonitorTaskDisplay) => JSX.Element;
    renderTaskLink: (task: IMonitorTaskDisplay, content: React.ReactNode, className: string) => JSX.Element;
}

const TableRow: FC<TableRowProps> = observer(({
    task,
    isSelected,
    isFavourite,
    onRowClick,
    onFavouriteClick,
    taskColumnDisplay,
    renderTaskLink
}) => {
    const handleFavouriteClick = useCallback((e: React.MouseEvent) => {
        e.stopPropagation();
        onFavouriteClick(task.id);
    }, [task.id, onFavouriteClick]);

    return (
        <tr
            className={isSelected ? "selected" : ""}
            onClick={() => onRowClick(task.id)}
        >
            <td className="first">
                <img
                    src={isFavourite ? StarActive : StarIdle}
                    className="star-button-img"
                    alt="Избранное"
                    onClick={handleFavouriteClick}
                />
            </td>
            <td className="user-monitor-widget-base-td idForView-td">
                <div className="user-monitor-widget-flexy-task-idForView-td user-monitor-task">
                    {renderTaskLink(task, task.code, "user-monitor-widget-flexy-project-td")}
                </div>
            </td>
            <td>
                <div className="user-monitor-widget-flexy-task-name-td user-monitor-task">
                    {renderTaskLink(task, task.name, "monitor-table-link-task-name")}
                </div>
            </td>
            <td className="user-monitor-widget-base-td">
                <div
                    className="user-monitor-widget-flexy-project-td"
                    title={task.project.name}
                >
                    {task.project.name}
                </div>
            </td>
            <td>{taskColumnDisplay(task)}</td>
            <td className="user-monitor-widget-base-td">{taskStatusDisplay(task)}</td>
            <td className="user-monitor-widget-base-td">{taskPriorityDisplay(task)}</td>
            <td className="user-monitor-widget-base-td">{taskTypeDisplay(task)}</td>
            <td className="user-monitor-widget-base-td">
                {task.startDate ? dateToNiceString(new Date(task.startDate), "dd.MM.yyyy") : ""}
            </td>
            <td className="last">
                {task.endDate ? dateToNiceString(new Date(task.endDate), "dd.MM.yyyy") : ""}
            </td>
        </tr>
    );
});

export default TableRow;